import TestTextAnswer from "./TestTextAnswer";

export default TestTextAnswer;
